import { ProductType } from '../types';

export interface OrganicOption {
  v: string;
  ico: string;
  t: string;
  s?: string;
  apiValue?: string;
}

export const PRODUCT_OPTS: OrganicOption[] = [
  { v: 'fotovoltaico', ico: 'sun', t: 'Fotovoltaico', s: 'Pannelli solari per la tua casa', apiValue: 'Photovoltaic' },
  { v: 'pompa', ico: 'heat', t: 'Pompa di Calore', s: 'Riscaldamento efficiente', apiValue: 'Heatpump' },
  { v: 'fv_pompa', ico: 'duo', t: 'Fotovoltaico + Pompa di Calore', s: 'La soluzione completa', apiValue: 'Photovoltaic + Heatpump' },
  { v: 'sostituzione', ico: 'swap', t: 'Sostituzione Impianto Fotovoltaico', s: 'Rinnova un impianto esistente', apiValue: 'PV_Retrofit' },
];

export const TIMELINE_OPTS: OrganicOption[] = [
  { v: '1-2', ico: 'alarm', t: 'Entro 1-2 mesi', apiValue: 'one_to_two_months' },
  { v: '3-4', ico: 'cal', t: 'Entro 3-4 mesi', apiValue: 'three_to_four_months' },
  { v: '5+', ico: 'cal', t: 'Fra + di 5 mesi', apiValue: 'more_than_5_months' },
  { v: 'nonso', ico: 'help', t: 'Non ho una scadenza precisa', apiValue: 'dont_know' },
];

export const HOME_OPTS: OrganicOption[] = [
  { v: 'schiera', ico: 'houses', t: 'Casa a schiera', apiValue: 'townhouse' },
  { v: 'singola', ico: 'house', t: 'Casa unifamiliare', apiValue: 'detached_house' },
  { v: 'palazzina', ico: 'build', t: 'Palazzina (fino a 6 famiglie)', apiValue: 'small_building' },
  { v: 'condominio', ico: 'houses', t: 'Condominio (più di 6 famiglie)', apiValue: 'multi_family_house' },
  { v: 'industriale', ico: 'ware', t: 'Edificio industriale / Capannone', apiValue: 'commercial_building' },
  { v: 'altro', ico: 'perg', t: 'Pergolati & Altro', apiValue: 'other' },
];

export const DECISION_OPTS: OrganicOption[] = [
  { v: 'evaluation', ico: 'check', t: 'So già che configurazione voglio', apiValue: 'evaluation' },
  { v: 'understand_purchase', ico: 'cal', t: 'Sto valutando diversi preventivi', apiValue: 'understand_purchase' },
  { v: 'understand_need', ico: 'help', t: 'Sto raccogliendo informazioni', apiValue: 'understand_need' },
  { v: 'curious', ico: 'sun', t: 'Sono solo curioso', apiValue: 'curious' },
];

export const SEARCH_TASKS = [
  'Localizzo il tuo Comune…',
  'Controllo gli incentivi statali 2026…',
  'Verifico i bonus regionali e locali…',
  'Calcolo il tuo risparmio stimato…',
];

export const INCENTIVES = [
  { ico: 'euro', t: 'Detrazione fiscale 50%', s: "Recuperi metà della spesa dell'impianto in 10 anni.", tag: 'Attivo' },
  { ico: 'shield', t: 'Bonus regionali', s: 'Contributi a fondo perduto attivi nella tua zona.', tag: 'Disponibile' },
  { ico: 'bolt', t: 'Conto Energetico Enpal', s: "Guadagni sull'energia che immetti in rete con CER e Enpal ONE", tag: 'Attivo' },
];

export const TOTAL_STEPS = 8;

/** @deprecated use TOTAL_STEPS */
export const FORM_STEPS = TOTAL_STEPS;

export const labelFor = (opts: OrganicOption[], v: string) => opts.find((x) => x.v === v)?.t || '';

export function mapProductToApi(v: string): ProductType {
  return (PRODUCT_OPTS.find((o) => o.v === v)?.apiValue as ProductType) || 'Photovoltaic';
}

export function mapToFormData(fields: {
  cap: string;
  product: string;
  home: string;
  timeline: string;
  decision: string;
  name: string;
  email: string;
  phone: string;
}) {
  return {
    zip: fields.cap,
    product_type: mapProductToApi(fields.product),
    house_type: HOME_OPTS.find((o) => o.v === fields.home)?.apiValue || '',
    purchase_time: TIMELINE_OPTS.find((o) => o.v === fields.timeline)?.apiValue || '',
    pv_interest_since: DECISION_OPTS.find((o) => o.v === fields.decision)?.apiValue || '',
    name: fields.name,
    email: fields.email,
    phone: fields.phone,
  };
}
